module.exports = __webpack_public_path__ + "img/how_do_they_work.25c21f5f.png";